import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

export const Nav = () => {
  const [hidden, setHidden] = useState(false);
  const [entered, setEntered] = useState(false);
  const last = useRef(0);

  useEffect(() => {
    const t = setTimeout(() => setEntered(true), 1900);
    if (!window.matchMedia("(max-width: 767px)").matches) return () => clearTimeout(t);
    const onScroll = () => {
      const y = window.scrollY;
      setHidden(y > 140 && y > last.current);
      last.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      clearTimeout(t);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      className="fixed inset-x-0 top-0 z-50 flex items-center justify-between px-6 py-6 md:px-10 md:py-8 pointer-events-none"
      style={{ mixBlendMode: "difference", color: "#F2F3F5" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: hidden ? 0 : 1, y: hidden ? -24 : 0 }}
      transition={entered ? { duration: 0.35, ease: "easeOut" } : { duration: 1.2, delay: 0.6 }}
      data-hidden={hidden ? "true" : "false"}
    >
      <a href="#top" data-testid="nav-wordmark" className="pointer-events-auto display text-[0.95rem] tracking-[0.18em] py-3" style={{ letterSpacing: "0.18em" }}>
        TELLTAG
      </a>
      <a href="#contact" data-testid="nav-contact-link" className="pointer-events-auto eyebrow py-3 pl-3">
        Contact
      </a>
    </motion.header>
  );
};
